import React from 'react';
import {NavLink} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import cn from 'classnames';

import {RoutesUrl} from 'utils/constants/routeConstants';

import {IContentNavItem, INavItem} from '../interfaces';
import {getLocalizedTitle} from '../utils';

import ProfileViewIcon from 'assets/image/mobile-nav/profile-view.svg';
import LogOutIcon from 'assets/image/mobile-nav/log-out.svg';

import '../styles.scss';

interface IProfileMenuProps {
  isOpen: boolean;
  locale: string;
  roles: string[];
  allowedNavItems: INavItem[];
  allowedContentNavItems: IContentNavItem[];
  onClickNavItem: (route: RoutesUrl) => () => void;
  onClickContentNavItem: () => void;
  onClickSettings: () => void;
  onSignOut: () => void;
}

export const ProfileMenu = ({
  isOpen,
  locale,
  roles,
  allowedNavItems,
  allowedContentNavItems,
  onClickNavItem,
  onClickContentNavItem,
  onClickSettings,
  onSignOut
}: IProfileMenuProps): JSX.Element => {
  return (
    <div className={cn('profile-menu', {'profile-menu--open': isOpen})}>
      {allowedNavItems.map((item) => {
        if (item.role && !roles.includes(item.role)) {
          return null;
        }

        return (
          <NavLink
            key={item.index}
            className="profile-menu__item"
            to={item.path}
            onClick={onClickNavItem(item.path)}
          >
            {getLocalizedTitle(item.title, item.titles, locale) || (
              <FormattedMessage
                id={`gritx.common.navigation.${item.translationKey || item.title}`}
                defaultMessage={item.title}
              />
            )}
          </NavLink>
        );
      })}
      {allowedContentNavItems.map((item) => {
        if (item.role && !roles.includes(item.role)) {
          return null;
        }

        return (
          <NavLink
            key={item.index}
            className="profile-menu__item"
            to={item.path}
            onClick={onClickContentNavItem}
          >
            {getLocalizedTitle(item.title, item.titles, locale) || (
              <FormattedMessage
                id={`gritx.common.navigation.${item.title}`}
                defaultMessage={item.title}
              />
            )}
          </NavLink>
        );
      })}
      <NavLink
        className="profile-menu__item"
        to={RoutesUrl.Settings}
        onClick={onClickSettings}
      >
        <img className="profile-menu__icon" src={ProfileViewIcon} alt="" role="presentation"/>
        <FormattedMessage
          id={'gritx.common.header.viewProfile'}
          defaultMessage={'View profile'}
        />
      </NavLink>
      <div className="profile-menu__divider"/>
      <NavLink
        className="profile-menu__item profile-menu__item--danger"
        to="/logout"
        onClick={onSignOut}
      >
        <img className="profile-menu__icon" src={LogOutIcon} alt="" role="presentation"/>
        <FormattedMessage
          id={'gritx.common.header.logOut'}
          defaultMessage={'Log out'}
        />
      </NavLink>
    </div>
  );
};
